import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-collaterals',
  templateUrl: './collaterals.component.html'
})
export class CollateralsComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  @Input() colaterals: any
  @Input() isLoan: any

  constructor(private fb: FormBuilder) { }

  form:any = this.fb.group({
    colaterals: new FormArray([]),
    colateralsDetails: ['', [Validators.required]],
  });

  // colaterasl = ['acciones','depositos','certificados','bienes','propiedades','otros'];

  ngOnChanges(): void {
    console.log(this.isLoan);
  }

  ngOnInit(): void {
    console.log(this.isLoan);
    this.formReady.emit(this.form);
    if(this.colaterals){
      this.form.patchValue(this.colaterals);
      let selectedColaterals = (this.form.controls['colaterals'] as FormArray);
      for(let colateteral of this.colaterals.colaterals){
        var checkbox:any = document.getElementById(colateteral);
        selectedColaterals.push(new FormControl(colateteral));
        checkbox.checked = true;
      }
      ;
    }
  }

  onCheckboxChange(event: any) {
    
    const selectedColaterals = (this.form.controls['colaterals'] as FormArray);
    if (event.target.checked) {
      selectedColaterals.push(new FormControl(event.target.value));
    } else {
      const index = selectedColaterals.controls
      .findIndex(x => x.value === event.target.value);
      selectedColaterals.removeAt(index);
    }
  }

}
